<div class="backdrop" [ngClass]="{ 'backdrop-visible': drawer.opened }" (click)="toggleReturnRemove()"></div>
<mat-sidenav #returnRemoveDrawer class="right-side-nav-container display-flex returnDrawer" opened="false" position="end" mode="over" [fixedInViewport]="true">
  <div mat-dialog-title>
    <div class="row row--space-between mb--md">
      <label>{{ 'App.ReturnRemove.Labels.ReturnRemove' | translate }}</label>
      <button mat-button class="float-right" (click)="toggleReturnRemove()">
        <span class="icon-x"></span>
      </button>
    </div>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="returnRemoveForm">
      <div class="mb--sm">
        <mat-radio-group formControlName="actionType">
            <div><mat-radio-button value="return">{{ 'App.ReturnRemove.Options.Return' | translate }}</mat-radio-button></div>
            <div><mat-radio-button value="remove">{{ 'App.ReturnRemove.Options.Remove' | translate }}</mat-radio-button></div>
          </mat-radio-group>
      </div>
      <div class="row display-column-flex column--12">
        <mat-form-field hideRequiredMarker appearance="outline">
          <mat-label>{{ 'App.ReturnRemove.Placeholders.PackageComment' | translate }}</mat-label>
          <input matInput formControlName="packageComment" />
          <mat-error>{{ 'App.ReturnRemove.Errors.InvalidComment' | translate }} </mat-error>
        </mat-form-field>
      </div>
      <!-- Route Code: Show this field only if courier is DHL -->
      <div *ngIf="showRouteCodeInput" class="row display-column-flex column--12">
        <mat-form-field hideRequiredMarker appearance="outline">
          <mat-label>{{ 'App.ReturnRemove.Placeholders.RouteCode' | translate }}</mat-label>
          <input matInput formControlName="routeCode" />
          <mat-error *ngIf="returnRemoveForm.get('routeCode')?.hasError('required')">{{ 'App.ReturnRemove.Errors.InvalidRouteCode' | translate }} </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div mat-dialog-actions class="mt--auto">
    <button mat-button class="critical-button rounded w-100 mb--sm" (click)="onSubmitAction()" [disabled]="returnRemoveForm.invalid">
      <span>{{ 'App.ReturnRemove.Buttons.Confirm' | translate }}</span>
    </button>
    <button mat-button class="hollow-button rounded w-100" (click)="toggleReturnRemove()">
      <span>{{ 'App.ReturnRemove.Buttons.Cancel' | translate }}</span>
    </button>
  </div>
</mat-sidenav>